import { RiseOutlined } from '@ant-design/icons'
import { Card, Space } from 'antd'
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts'
import { getOrderTrends } from '../../dashboardActions';
import dayjs from 'dayjs';

const OrderTrends = ({ height = 350 }) => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const orderTrendsOptions = {
        chart: {
            type: 'area',
            height: 350,
            toolbar: { show: false },
            zoom: { enabled: false },
            foreColor: '#333'
        },
        stroke: {
            curve: 'smooth',
            width: 3
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.1,
                stops: [0, 90, 100]
            }
        },
        xaxis: {
            labels: {
                rotate: -45,
                style: {
                    fontSize: '12px',
                    fontWeight: 500,
                    colors: '#999'
                }
            },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        yaxis: {
            title: { text: 'Orders' },
            labels: {
                style: {
                    fontSize: '13px',
                    fontWeight: 500,
                    colors: '#999'
                }
            }
        },
        grid: {
            borderColor: '#eee',
            strokeDashArray: 5,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } }
        },
        colors: ['#5c6bc0'],
        markers: {
            size: 5,
            colors: ['#fff'],
            strokeColors: '#5c6bc0',
            strokeWidth: 3,
            hover: { size: 7 }
        },
        tooltip: {
            theme: 'light',
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const dataPoint = w.config.series[seriesIndex].data[dataPointIndex];
                return `
                    <div style="
                        font-family: 'Arial', sans-serif;
                        font-size: 13px;
                        background: #fff;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                        overflow: hidden;
                        min-width: 120px;
                    ">
                        <div style="
                        background: #f0f2f5;
                        padding: 10px 12px;
                        font-size: 14px;
                        font-weight: 600;
                        border-bottom: 1px solid #e5e5e5;
                        color: #333;
                        ">
                        ${dataPoint.x}
                        </div>
                        <div style="padding: 10px 12px; color: #555;">
                        <div style="margin-bottom: 6px;">
                            <strong>Orders:</strong> ${dataPoint.y}
                        </div>
                        <div>
                            <strong>Quantity:</strong> ${dataPoint.quantity}
                        </div>
                        </div>
                    </div>
                `;
            }
        }

    };

    useEffect(() => {
        getOrderTrends().then(response => {
            if (response?.ack) {
                const trendsData = response?.sale_quantities?.map(item => ({
                    x: dayjs(item.posting_date).format('D MMM'),
                    y: item.total_orders || 0,
                    quantity: item.total_quantity || 0
                }));

                setData({
                    series: [
                        {
                            name: 'Orders',
                            data: trendsData,
                        }
                    ]
                });
            }
        }).finally(() => {
            setLoading(false)
        });
    }, []);

    return (
        <Card
            title={
                <Space>
                    <RiseOutlined style={{ color: '#5c6bc0' }} />
                    <span style={{ fontWeight: 600 }}>Order Fulfilled Trends</span>
                </Space>
            }
            styles={{
                header: { background: '#f5f5f5' },
                body: { padding: '24px' }
            }}
            style={{
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                border: '1px solid #f0f0f0',
                height: '100%',
                minHeight: height
            }}
            loading={loading}
        >
            <Chart
                options={{ ...orderTrendsOptions, xaxis: { ...orderTrendsOptions.xaxis, categories: data?.categories || [] } }}
                series={data?.series || []}
                type="line"
                height={height}
            />
        </Card>)
}

export default OrderTrends